import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import DeudasManager from "./DeudasManage";

// Usamos arrow function para mantener consistencia
const DeudasForm = ({ procesoId }) => {
  const [showNewDeudaModal, setShowNewDeudaModal] = useState(false);

  return (
    <Box>
      <DeudasManager
        procesoId={procesoId}
        showNewDeudaModal={showNewDeudaModal}
        setShowNewDeudaModal={setShowNewDeudaModal}
      />
    </Box>
  );
};

DeudasForm.propTypes = {
  procesoId: PropTypes.number.isRequired,
};

export default DeudasForm;
